export default {
  // Navbar
  "nav.home": "Acasă",
  "nav.about": "Despre noi",
  "nav.gallery": "Galerie",
  "nav.news": "Știri",
  "nav.useful": "Utile",
  "nav.programs": "Programe",
  "nav.contact": "Contact",
  "nav.toggle_menu": "Toggle menu",

  // Language Switcher
  "lang.switch_to": "EN",
  "lang.current": "RO",

  // Footer — Brand
  "footer.tagline": "Federația Organizațiilor de Pescari de la Marea Neagră — organizație profesională reprezentativă a pescarilor profesioniști maritimi din România.",
  "footer.nav_title": "Navigare rapidă",
  "footer.legal_title": "Legal",
  "footer.contact_title": "Contact",

  // Footer — quick links
  "footer.link_home": "Acasă",
  "footer.link_about": "Despre noi",
  "footer.link_gallery": "Galerie",
  "footer.link_news": "Știri",
  "footer.link_programs": "Programe",
  "footer.link_contact": "Contact",
  "footer.link_fishing": "Pescuitul românesc",
  "footer.link_fishermen": "Pescarii profesioniști",
  "footer.link_gastronomy": "Gastronomia pescărească",
  "footer.link_calcan": "Calcan",

  // Footer — legal links
  "footer.link_statute": "Statut FOPMN",
  "footer.link_privacy": "Politica de confidențialitate",
  "footer.link_cookies": "Politica privind modulele cookie",
  "footer.link_terms": "Termeni și condiții",

  // Footer — contact
  "footer.address": "Str. Smaraldului nr. 11, ap. 6, Constanța, jud. Constanța, CP: 900001",
  "footer.phone_president": "0723 633 364",
  "footer.email_president": "Lmirea@ymail.com (Președinte)",
  "footer.email_official": "office@federatiapescarilormareaneagra.ro",

  // Footer — copyright
  "footer.copyright": "FOPMN — Federația Organizațiilor de Pescari de la Marea Neagră. Toate drepturile rezervate.",
  "footer.created_by": "Creat de Agenția web design",

  // Cookie Banner
  "cookie.text": "Site-ul nostru utilizează module cookie esențiale pentru funcționare și module cookie de analiză anonimă pentru a înțelege cum interacționează vizitatorii cu conținutul nostru. Nu folosim cookie-uri de marketing și nu transmitem datele tale către terți.",
  "cookie.essential": "Doar cele esențiale",
  "cookie.accept_all": "Accept toate",
};